<template>
  <div class="exr-dwtk-form">
    <el-form-item label="题干" @change.native.capture="handleDialogText(form, 'subject', 'subjectPinyin')">
      <PinyinGridInput 
        v-if="config.pinyin" 
        :text.sync="form.subject" 
        :pinyin.sync="form.subjectPinyin"
        :input-filter="inputFilter"
        preview-classes="subject-part subject-preview"
        :preview-filter="previewFilter"
        :word-tags="{'word-blank': /^__+$/}"
      ></PinyinGridInput>
      <el-input class="subject-part subject-input" 
        v-else
        type="textarea" 
        v-model="subject" 
        resize="none" 
        :autosize="{minRows:2}" 
        placeholder="在这里输入文本" 
        @input="onChangeSubject"
      ></el-input>
    </el-form-item>
    <el-form-item label="图片" v-if="config.image">
      <ImageInput v-model="form.image" :desc.sync="form.imageDesc"></ImageInput>
    </el-form-item>
    <el-form-item label="小题">
      <el-collapse v-model="collapse" accordion class="exr-child-collapse">
        <el-collapse-item :name="key" v-for="(child, key) in form.children" :key="key">
          <template v-slot:title>
            {{key + 1}})&nbsp;&nbsp;<span :class="{answered: cix === child.answer}" v-for="(item, cix) in child.items" :key="cix">{{cix + 1}}.{{item.text}}&nbsp;&nbsp;&nbsp;</span>
          </template>
          <ChildItem  v-model="form.children[key]" :config="config" :number="key+1"></ChildItem>
        </el-collapse-item>
      </el-collapse>
    </el-form-item>
    <ShowAnswer v-model="form" :config="config"></ShowAnswer>
  </div>
</template>

<script>
  import dialog from '@/components/mixins/dialog.js'
  import ChildItem from './ChildItem'
  import PinyinGridInput from "@/components/PinyinGridInput"
  // import FileInput from "@/components/FileInput"
  import ImageInput from "@/components/ImageInput"
  import ShowAnswer from "./ShowAnswer"

  export default {
    name: 'DwtkForm',
    components: {
      PinyinGridInput,
      //FileInput,
      ImageInput,
      ChildItem,
      ShowAnswer
    },
    mixins: [dialog],
    props: {
      config: {},
      model: {}
    },
    data () {
      let data = {
        collapse: ''
      }
      this.normalizedModel(data, this.model)
      return data
    },
    watch: {
      model (val) {
        this.normalizedModel(this, val)
      },
    },
    computed: {
      showAddChild () {
        return this.config.maxBlankCount === 0 || this.config.maxBlankCount > this.form.children.length
      }
    },
    methods: {
      normalizedModel (data, model) {
        if (this.config.pinyin) {
          data.form = Object.assign({subject: '', subjectPinyin: '', children: []}, model)
          data.subject = model.subject || ''
          data.subjectPinyin = model.subjectPinyin || ''
        } else {
          data.form = Object.assign({subject: '', children: []}, model)
          data.subject = model.subject || ''
        }
        data.blankLength = model.subject ? model.subject.match(/__/g).length : 0
        this.resetChildren(data, data.form)
      },
      resetChildren (data, model) {
        let count = Math.max(this.config.minBlankCount, 1, data.blankLength)
        if (model.children.length < count) {
          model.children = model.children.concat(Array(Math.max(count - model.children.length, 1)).fill().map(() => {
            return {
              items: [],
              answer: null
            }
          }))
        } else if(model.children.length > count) {
          model.children.splice(count)
        }
        model.children.forEach((n, i) => {
          n.nid = i + 1
          if (!n.items) {
            this.$set(n, 'items', [])
          }
          if (n.answer === undefined) {
            this.$set(n, 'answer', null)
          }
        })
      },
      addChild (index) {
        this.form.children.splice(index + 1, 0, {})
      },
      removeChild (index) {
        if (this.form.children.length > 1 && this.config.minBlankCount < this.form.children.length) {
          this.form.children.splice(index, 1)
        } else {
          this.form.children.splice(index, 1, {})
        }
      },
      getChildLabel (child, number) {
        return number + ') ' + child.items.map((n, i) => {
          let classes = i === child.answer ? ' answered' : ''
          return `<span${classes}>${i + 1}. ${n.text}</span>`
        }).join('　　')
      },
      inputFilter (val, type) {
        val = val.replace(/[_＿]{2,}/g, '__').replace(/ {2,}/g, '　　')
        if (type === 'text') {
          this.blankLength = val.match(/__/g).length
          this.resetChildren(this, this.form)
        }
        return val
      },
      previewFilter (val, type) {
        if (type === 'text') {
          let index = 0
          return val.replace(/[_＿]{2,}/g, (m) => {
            return `<blank>${++index}</blank>`
          })
        }
        return val.replace(/[_＿]{2,}/g, '')
      },
      onChangeSubject () {
        this.form.subject = this.inputFilter(this.form.subject, 'text')
      }
    }
  }
</script>

<style lang="scss">
  .dwtk-blank, blank{
    display: inline-block;
    width: 40px;
    color:#409EFF;
    text-align: center;
    border-bottom: 1px solid #409EFF;
  }
  .exr-child-collapse{
    margin-top:-5px;
    .el-collapse-item__content{
      padding-bottom: 15px;
    }
  }
  .exr-child{
    position: relative;
    .el-form-item{
      margin-top: 15px;
    }
    .el-form-item__label{
      text-align: left;
      width: 60px !important;
    }
    .el-form-item__content{
      margin-left: 60px !important;
    }
  }
  .exr-dwtk-form{
    .subject-part{
      +.subject-part{
        margin-top: 8px;
      }
    }
    .subject-preview{
      line-height: 1.5;
      border: 1px solid #DCDFE6;
      padding: 5px 10px;
      border-radius: 4px;
      font-size: 16px;
    }
    .word-blank{
      color:#409EFF;
    }
  }
</style>
